import '../style/footer.css';

const Footer = () => {
    return(
        <div className = "footer-body"> 
            <span className = "footer-copyright"> Copyright © 2023, UPLB Cashier’s Office. All rights reserved. </span>  

            <span className = "footer-email"> cash@uplb.edu.ph </span> 
             
            <span className = "footer-tel"> (049) 536-3558 </span> 
        </div>
    );
}

export default Footer;